import { Swiper, Navigation, Pagination, Autoplay } from "swiper/bundle";
export default class SwiperCards2 {
    constructor() {
        console.log('%c👍🏼 Swiper Cards 2', 'color: yellow');
        
        this.swiper2 = document.querySelectorAll(
            '.swiper--cards-2'
        )
    }
    
    init() {

       
        this.swiper2.forEach((elem, i) => {
            let count = elem.querySelectorAll('.swiper-slide').length;
            new Swiper(elem, {
                slidesPerView: 1.5,
                loop: true,
                spaceBetween: 15,
                speed: 1001,
                pagination: {
                    el: '.swiper-pagination',
                    type: 'fraction',
                    formatFractionCurrent: function (number) {

                        if(number != 1) {
                            number = count - number + 2;
                        }
                        if (number < 10) {
                            number = '0' + number;
                        }
                        return number;
                    },
                    formatFractionTotal: function (number) {
                        if (number < 10) {
                            number = '0' + number;
                        }
                        return number;
                    }
                  },
                navigation: {
                    nextEl: ".swiper-button-next",
                    prevEl: ".swiper-button-prev",
                },
                breakpoints: {
                    540: {
                        slidesPerView: 2.5
                    },
                   
                   
                }
            });   
        })
    }
}